import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=87dcf5b4"
import script from "./ModalContainer.vue?vue&type=script&lang=ts"
export * from "./ModalContainer.vue?vue&type=script&lang=ts"
import style0 from "./ModalContainer.vue?vue&type=style&index=0&id=87dcf5b4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87dcf5b4')) {
      api.createRecord('87dcf5b4', component.options)
    } else {
      api.reload('87dcf5b4', component.options)
    }
    module.hot.accept("./ModalContainer.vue?vue&type=template&id=87dcf5b4", function () {
      api.rerender('87dcf5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalContainer.vue"
export default component.exports